const API_KEY = 'AIzaSyAWiKd4NgXje-XE8WNDAlV8x-DzXTXQwFA';

export {
    API_KEY
}